import policies from "./policies"
import cases from "./cases"
import transactions from "./transactions"

const queryList = [policies, cases, transactions]

export default queryList
